import { useCallback } from "react";
import { Trk } from "../../../constants/constants";
import { getSalesforceDoc } from "../../../services/modelPortfoliosApi";
import AnalyticsHelper from "../../../utils/analyticsHelper";
import { RequestDownloadDocument } from "../../../constants/modelPortfoliosConstants";

const useTrackDocDownloadSF = () => {
    const trackDocDownload = useCallback(async (id, name, portfolioId) => {
        switch (id) {
            case RequestDownloadDocument.InvestorPack:
                {
                    AnalyticsHelper.Track(Trk.SMA.INVESTOR_PACK_DOWNLOADED, {
                        category: "investor",
                        action: "pack_downloaded"
                    });
                    await getSalesforceDoc(id, name, portfolioId);
                    break;
                }
            case RequestDownloadDocument.FeesSpecialReport:
                {
                    AnalyticsHelper.Track("fees_report_downloaded", {
                        category: "fees",
                        action: "report_downloaded"
                    });
                    break;
                }
            case RequestDownloadDocument.ETF_Report:
                {
                    AnalyticsHelper.Track("fees_report_downloaded", {
                        category: "etf",
                        action: "report_downloaded"
                    });
                    break;
                }
        }
    }, []);
    return trackDocDownload 
};

export default useTrackDocDownloadSF;
